<template>
    <zen-one :showuserinfo="false" :title="'Dashboard PTJ'" :crumbs="crumbs">
        <z-animate-number value="29"></z-animate-number>

        <w-card class="mb3">
            <table style="width: 100%" class="mb2 table-dashboard">
                <thead>
                    <tr class="text-center">
                        <td class="">JABATAN</td>
                        <td class="" colspan="3">Sehingga Februari 2022</td>
                        <td class="" colspan="3">Sehingga Februari 2021</td>
                        <td class=" " colspan="3">Sehingga Februari 2022</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row-data">
                        <td></td>
                        <td class="warning-light1--bg">ANGGARAN (RM)</td>
                        <td class="deep-orange-light1--bg">KUTIPAN (RM)</td>
                        <td class="amber-light1--bg">%</td>

                        <td class="warning-light1--bg">ANGGARAN (RM)</td>
                        <td class="deep-orange-light1--bg">KUTIPAN (RM)</td>
                        <td class="amber-light1--bg">%</td>

                        <td class="warning-light1--bg">ANGGARAN (RM)</td>
                        <td class="deep-orange-light1--bg">KUTIPAN (RM)</td>
                        <td class="amber-light1--bg">%</td>
                    </tr>
                    <!-- <tr class="table-row-data">
                        <td class="text-bold">
                            Pejabat Pengarah Tanah dan Galian Negeri
                        </td>
                        <td class="warning-light1--bg">22,507,560.00</td>
                        <td class="deep-orange-light1--bg">7,597,131.68</td>
                        <td class="amber-light1--bg">33.75%</td>
                        <td class="warning-light1--bg">21,986,390.00</td>
                        <td class="deep-orange-light1--bg">46,074,142.02</td>
                        <td class="amber-light1--bg">209.56%</td>
                        <td class="warning-light1--bg">17,248,766.00</td>
                        <td class="deep-orange-light1--bg">10,394,626.77</td>
                        <td class="amber-light1--bg">60.26%</td>
                    </tr> -->
                    <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Bandar Baharu</td>
                        <td class="warning-light1--bg">6,337,823.00</td>
                        <td class="deep-orange-light1--bg">950,268.95</td>
                        <td class="amber-light1--bg">14.99%</td>
                        <td class="warning-light1--bg">4,756,300.00</td>
                        <td class="deep-orange-light1--bg">442,500.55</td>
                        <td class="amber-light1--bg">9.30%</td>
                        <td class="warning-light1--bg">6,723,411.00</td>
                        <td class="deep-orange-light1--bg">957,524.45</td>
                        <td class="amber-light1--bg">14.24%</td>
                    </tr>
                    <!-- <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Langkawi</td>
                        <td class="warning-light1--bg">80,102,951.00</td>
                        <td class="deep-orange-light1--bg">5,128,678.25</td>
                        <td class="amber-light1--bg">6.40%</td>
                        <td class="warning-light1--bg">122,146,260.00</td>
                        <td class="deep-orange-light1--bg">1,302,343.05</td>
                        <td class="amber-light1--bg">1.07%</td>
                        <td class="warning-light1--bg">129,058,993.00</td>
                        <td class="deep-orange-light1--bg">3,836,191.83</td>
                        <td class="amber-light1--bg">2.97%</td>
                    </tr>
                    <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Yan</td>
                        <td class="warning-light1--bg">5,211,600.00</td>
                        <td class="deep-orange-light1--bg">630,181.99</td>
                        <td class="amber-light1--bg">12.09%</td>
                        <td class="warning-light1--bg">4,607,990.00</td>
                        <td class="deep-orange-light1--bg">375,330.07</td>
                        <td class="amber-light1--bg">8.15%</td>
                        <td class="warning-light1--bg">4,985,511.00</td>
                        <td class="deep-orange-light1--bg">854,654.81</td>
                        <td class="amber-light1--bg">17.14%</td>
                    </tr>
                    <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Padang Terap</td>
                        <td class="warning-light1--bg">19,157,853.00</td>
                        <td class="deep-orange-light1--bg">716,018.20</td>
                        <td class="amber-light1--bg">3.74%</td>
                        <td class="warning-light1--bg">17,108,640.00</td>
                        <td class="deep-orange-light1--bg">1,402,042.40</td>
                        <td class="amber-light1--bg">8.19%</td>
                        <td class="warning-light1--bg">17,475,842.00</td>
                        <td class="deep-orange-light1--bg">1,438,243.15</td>
                        <td class="amber-light1--bg">8.23%</td>
                    </tr>
                    <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Sik</td>
                        <td class="warning-light1--bg">13,180,174.00</td>
                        <td class="deep-orange-light1--bg">2,846,945.21</td>
                        <td class="amber-light1--bg">21.60%</td>
                        <td class="warning-light1--bg">21,838,580.00</td>
                        <td class="deep-orange-light1--bg">1,045,142.36</td>
                        <td class="amber-light1--bg">4.79%</td>
                        <td class="warning-light1--bg">10,355,005.00</td>
                        <td class="deep-orange-light1--bg">1,723,397.60</td>
                        <td class="amber-light1--bg">16.64%</td>
                    </tr>
                    <tr class="table-row-data">
                        <td class="text-bold">Pejabat Tanah Pendang</td>
                        <td class="warning-light1--bg">14,935,933.00</td>
                        <td class="deep-orange-light1--bg">1,557,142.47</td>
                        <td class="amber-light1--bg">10.43%</td>
                        <td class="warning-light1--bg">15,779,310.00</td>
                        <td class="deep-orange-light1--bg">1,881,746.38</td>
                        <td class="amber-light1--bg">11.93%</td>
                        <td class="warning-light1--bg">15,045,816.00</td>
                        <td class="deep-orange-light1--bg">1,423,234.09</td>
                        <td class="amber-light1--bg">9.46%</td>
                    </tr>
                    <tr class="table-row-data">
                        <td class="text-bold">JUMLAH HASIL TANAH</td>
                        <td class="warning-light1--bg">490,013,750.00</td>
                        <td class="deep-orange-light1--bg">56,390,010.97</td>
                        <td class="amber-light1--bg">11.51%</td>
                        <td class="warning-light1--bg">501,694,290.00</td>
                        <td class="deep-orange-light1--bg">72,830,278.49</td>
                        <td class="amber-light1--bg">14.52%</td>
                        <td class="warning-light1--bg">499,000,000.00</td>
                        <td class="deep-orange-light1--bg">57,347,615.15</td>
                        <td class="amber-light1--bg">11.49%</td>
                    </tr> -->
                </tbody>
            </table>
        </w-card>

        <w-flex class="row mb3">
            <w-card class="xs12">
                <div class="dashboard-title">
                    RUMUSAN KUTIPAN BULAN FEBRUARI BAGI TAHUN 2022, 2021 DAN
                    2020 BAGI PEJABAT TANAH BANDAR BAHARU
                </div>
                <fusioncharts
                    :type="chart1.type"
                    :width="chart1.width"
                    :height="chart1.height"
                    :dataformat="chart1.dataFormat"
                    :dataSource="chart1.dataSource"
                >
                </fusioncharts>
            </w-card>
        </w-flex>
    </zen-one>
</template>

<script>
export default {
    components: {},
    setup() {
        return {};
    },
    data() {
        return {
            chart1: {
                type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        // caption: "Split of visitors by Channels",
                        // placevaluesinside: "1",
                        // showvalues: "1",
                        // plottooltext:
                        //     "<b>$dataValue</b> $seriesName Pada $label",
                        theme: "fusion",
                        // caption: "Revenues and Profits",
                        // subCaption: "For last year",
                        // xAxisname: "Month",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        // numberPrefix: "$",
                        sNumberSuffix: "%",
                        // sYAxisMaxValue: "300",
                    },
                    categories: [
                        {
                            category: [
                                {
                                    label: "Februari 2022",
                                },
                                {
                                    label: "Februari 2021",
                                },
                                {
                                    label: "Februari 2020",
                                },
                            ],
                        },
                    ],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: "6337823.00" },
                                { value: "4756300.00" },
                                { value: "6723411.00" },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: "950268.95" },
                                { value: "442500.55" },
                                { value: "957524.45" },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {
                                    value: "14.99",
                                },
                                {
                                    value: "9.3",
                                },
                                {
                                    value: "14.24",
                                },
                            ],
                        },
                    ],
                },
            },
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Dashboard PTJ", route: "/w-breadcrumbs" },
            ],
            showCard: false,
        };
    },
    methods: {},
};
</script>

<style>
.dashboard-box .w-image {
    background-size: contain;
}
.zdiimage {
    margin-right: 7px;
}
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}
.dashboard-percentage {
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 20px;
}
.dashboard-percentage-no {
    font-size: 20px;
}
.dashboard-more {
    position: absolute;
    right: 20px;
    top: 30px;
    color: #fff;
    background: #1f2248;
    padding: 3px 15px;
    border-radius: 5px;
    border: none;
}
.table-row-data {
    text-align: right;
}
</style>
